export default "__VITE_ASSET__BPIgnHhu__"